export enum StoresEndpoints {
  STORES = '/stores',
}

export interface IStore {
  id: string;
  title: string;
  slug: string;
}

export interface IGetStoresDTO {
  title?: string;
}

export interface IStoreResponse {
  data: IStore[];
}
